import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { CarriersTable } from "./components/CarriersTable";
import { CreateCarrier } from "./components/CreateCarrier";

const Carriers = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Carriers");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Carriers" },
        ]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title="Carriers"
                subtitle="View and manage insurance carrier records"
            >
                <CreateCarrier />
            </AdminPageHeader>

            <div className="mt-6">
                <CarriersTable />
            </div>
        </AdminPageContent>
    );
};

export default Carriers;
